export function normalizeSourceUrl(value: unknown): string | null {
  const rawValue = String(value ?? "").trim();
  if (!rawValue) return null;
  try {
    const candidate = /^https?:\/\//i.test(rawValue)
      ? rawValue
      : `https://${rawValue}`;
    const parsed = new URL(candidate);
    if (
      (parsed.protocol !== "http:" && parsed.protocol !== "https:") ||
      !parsed.hostname ||
      parsed.username ||
      parsed.password
    )
      throw new Error("INVALID_SOURCE_URL");
    return parsed.toString();
  } catch {
    throw new Error("INVALID_SOURCE_URL");
  }
}
